import { css } from "@emotion/css";

function resolveStyleValue(value, props) {
  if (typeof value === "function") {
    return value(props);
  }

  if (Array.isArray(value)) {
    return value.map((item) => resolveStyleValue(item, props));
  }

  if (value && typeof value === "object") {
    return Object.entries(value).reduce((resolved, [key, nestedValue]) => {
      resolved[key] = resolveStyleValue(nestedValue, props);
      return resolved;
    }, {});
  }

  return value;
}

export function createClasses(stylesInput, theme, props = {}) {
  const styles =
    typeof stylesInput === "function" ? stylesInput(theme) : stylesInput;

  return Object.entries(styles || {}).reduce((classes, [slot, style]) => {
    classes[slot] = css(resolveStyleValue(style, props));
    return classes;
  }, {});
}
